import React from "react";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ExtensionIcon from "@mui/icons-material/Extension";
import "../styles/BottomNav.css";

export default function BottomNav({ activeView, practiceType, onNavigate }) {
  const items =
    practiceType === "chinese"
      ? [
          { id: "chinese-flashcards",   icon: <MenuBookIcon />,   label: "Flash Cards" },
          { id: "chinese-char-spelling", icon: <SpellcheckIcon />, label: "Spelling" },
          { id: "games",                icon: <ExtensionIcon />,  label: "Games" },
          { id: "wordlist",             icon: <ListAltIcon />,    label: "Words" },
        ]
      : [
          { id: "flashcards", icon: <MenuBookIcon />,   label: "Flash Cards" },
          { id: "spelling",   icon: <SpellcheckIcon />, label: "Spelling" },
          { id: "games",      icon: <ExtensionIcon />,  label: "Games" },
          { id: "wordlist",   icon: <ListAltIcon />,    label: "Words" },
        ];

  return (
    <nav className="bottom-nav-bar">
      {items.map(item => (
        <button
          key={item.id}
          className={`bottom-nav-item${activeView === item.id ? " active" : ""}`}
          onClick={() => onNavigate(item.id)}
        >
          {item.icon}
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
